import React from "react";
import { Dropdown } from "flowbite-react";
import { MdKeyboardArrowRight } from "react-icons/md";

import { useState } from "react";
import { useEffect } from "react";
import { setCommonFilters } from "../../WorkbookSlice";
import { useDispatch } from "react-redux";
import { FaXmark } from "react-icons/fa6";
import { breakValue, handleFilterInDashboard } from "../../../smallFunction/SmallFunctions";
import { thisToThisDateFunction } from "../../utils/relativeDates/thisToThisDateFunction";
import { lastToNextDateFunction } from "../../utils/relativeDates/lastToNextDateFunction";
import { TimePeriodSelector } from "../Aside2Components/DropzoneComponents/Date/TimePeriodSelector";

const rightSideOptions = [
  { value: "Days" },
  { value: "Weeks" },
  { value: "Months" },
  { value: "Quarters" },
  { value: "Years" },
];

export default function Aside3RelativeDate({
  relativeDateItem,
  Sheetid,
  dashboardSheetID: dashIDs,
  isFilterVisibleInDashboard,
  dashboardType,
}) {
  // console.log(relativeDateItem);
  // console.log(relativeDateItem.relativeDateIs);
  // console.log(relativeDateItem.dateUnit);

  const dispatch = useDispatch();
  const result =
    relativeDateItem !== undefined &&
    relativeDateItem.relativeDateIs !== undefined
      ? breakValue(relativeDateItem.relativeDateIs, "aside3SideBar")
      : null;
  // console.log(result);
  const { period, value, unit } =
    result !== undefined && result !== null && result;
  const [selectedUnit, setSelectedUnit] = useState();
  // console.log(selectedUnit);

  const [selectedOption, setSelectedOption] = useState();
  // console.log(selectedOption);

  const [lastValue, setLastValue] = useState(5);
  // console.log(lastValue);

  const [nextValue, setNextValue] = useState(5);
  // console.log(nextValue);

  const [previewSectionValue, setPreviewSectionValue] = useState(null);
  // console.log(previewSectionValue);

  useEffect(() => {
    if (period !== undefined) {
      // console.log(period);
      switch (period) {
        case 0:
          setSelectedOption(0);
          break;
        case 1:
          setSelectedOption(1);
          break;
        case 2:
          setSelectedOption(2);
          break;
        case "Last":
          setSelectedOption(3);
          if (value === undefined) {
            setLastValue(5);
          }
          setLastValue(value);
          break;
        case "Next":
          setSelectedOption(4);
          if (value === undefined) {
            setNextValue(5);
          }
          setNextValue(value);
          break;
        default:
          break;
      }
    }
  }, [period]);

  useEffect(() => {
    if (relativeDateItem?.dateUnit !== undefined) {
      setSelectedUnit(relativeDateItem.dateUnit);
    }
  }, [relativeDateItem.dateUnit]);

  const Option = (selectedOption, selectedUnit, lastValue, nextValue) => {
    // console.log(selectedOption);

    // console.log(selectedUnit);

    // console.log(lastValue);

    // console.log(nextValue);

    if (selectedOption === 0) {
      switch (selectedUnit) {
        case "Days":
          return "Yesterday";
        case "Weeks":
          return "Last Week";
        case "Months":
          return "Last Month";
        case "Quarters":
          return "Last Quarter";
        case "Years":
          return "Last Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 1) {
      switch (selectedUnit) {
        case "Days":
          return "Today";
        case "Weeks":
          return "This Week";
        case "Months":
          return "This Month";
        case "Quarters":
          return "This Quarter";
        case "Years":
          return "This Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 2) {
      switch (selectedUnit) {
        case "Days":
          return "Tomorrow";
        case "Weeks":
          return "Next Week";
        case "Months":
          return "Next Month";
        case "Quarters":
          return "Next Quarter";
        case "Years":
          return "Next Year";
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 3) {
      switch (selectedUnit) {
        case "Days":
          return `Last ${lastValue} Days`;
        case "Weeks":
          return `Last ${lastValue} Weeks`;
        case "Months":
          return `Last ${lastValue} Months`;
        case "Quarters":
          return `Last ${lastValue} Quarters`;
        case "Years":
          return `Last ${lastValue} Years`;
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 4) {
      switch (selectedUnit) {
        case "Days":
          return `Next ${nextValue} Days`;
        case "Weeks":
          return `Next ${nextValue} Weeks`;
        case "Months":
          return `Next ${nextValue} Months`;
        case "Quarters":
          return `Next ${nextValue} Quarters`;
        case "Years":
          return `Next ${nextValue} Years`;
        default:
          return ""; // Default case if none match
      }
    } else if (selectedOption === 5) {
      switch (selectedUnit) {
        case "Days":
          return "Day to Day";
        case "Weeks":
          return "Week to Week";
        case "Months":
          return "Month to Month";
        case "Quarters":
          return "Quarter to Quarter";
        case "Years":
          return "Year to Year";
        default:
          return ""; // Default case if none match
      }
    }
    return "";
  };
  const aside3RelativeDateIs = Option(
    selectedOption,
    selectedUnit,
    lastValue,
    nextValue
  );
  // console.log(aside3RelativeDateIs);
  useEffect(() => {
    // console.log(aside3RelativeDateIs);
    if (aside3RelativeDateIs !== "") {
      const localResult = breakValue(aside3RelativeDateIs, "buildQuery");
      // console.log(localResult);
      if (localResult) {
        const { period, value, unit } = localResult;
        // console.log(period, value, unit);
        const { minValue, maxValue } = lastToNextDateFunction({
          period,
          value,
          unit,
        });
        // console.log(minValue, maxValue);
        setPreviewSectionValue({ fromDateTo: minValue, toThisDate: maxValue });
      } else {
        const { minValue, maxValue } = thisToThisDateFunction(
          aside3RelativeDateIs,
          selectedUnit
        );
        // console.log(minValue, maxValue);
        setPreviewSectionValue({ fromDateTo: minValue, toThisDate: maxValue });
      }
    }
  }, [aside3RelativeDateIs]);

  const dispatchRelativeDateFilter = (value, operation) => {
    // console.log(value);
    dispatch(
      setCommonFilters({
        operation,
        value,
        Sheetid,
      })
    );
  };
  useEffect(() => {
    // console.log({
    //   ...relativeDateItem,
    //   relativeDateIs: aside3RelativeDateIs,
    //   dateUnit: selectedUnit,
    // });
    const updatedItem = {
      ...relativeDateItem,
      relativeDateIs: aside3RelativeDateIs,
      dateUnit: selectedUnit,
    };
    const operation = "UPDATE";
    // console.log(updatedItem);
    
    dispatchRelativeDateFilter(updatedItem, operation);
  }, [selectedOption, selectedUnit, lastValue, nextValue]);

  return (
    <main className="w-full flex flex-col gap-1 items-center justify-between px-1">
      <section className="w-full flex items-center justify-between font-light">
        {relativeDateItem.rename}
        {dashboardType === "makeDashboard" && isFilterVisibleInDashboard ? (
          <FaXmark
            className="font-light cursor-pointer text-transparent hover:text-gray-600"
            onClick={() =>
              handleFilterInDashboard({
                item: relativeDateItem,
                dashIDs,
                dispatch,
                setCommonFilters,
              })
            }
          />
        ) : null}
      </section>
      <section className="w-full flex items-center justify-between rounded border font-light text-sm px-1">
        {relativeDateItem.relativeDateIs}
        {/* <MdKeyboardArrowDown className="text-2xl text-gray-400" /> */}
        {selectedUnit !== undefined && selectedOption !== undefined && (
          <Dropdown
            label={
              <MdKeyboardArrowRight className="text-2xl text-gray-600 cursor-pointer relative left-[84%]" />
            }
            placement="bottom"
            dismissOnClick={true}
            style={{ position: "relative", right: "10px" }}
            className="w-[20rem] -mt-[0.4rem] ml-[5px]"
          >
            {TimePeriodSelector({
              selectedUnit,
              selectedOption,
              setSelectedOption,
              lastValue,
              setLastValue,
              nextValue,
              setNextValue,
              rightSideOptions,
              setSelectedUnit,
              visibleInAside3SideBar: true,
            })}
            {previewSectionValue !== null ? (
              <section className="w-full font-light text-[12px] flex items-center justify-center gap-2">
                <button>{previewSectionValue.fromDateTo}</button>-
                <button>{previewSectionValue.toThisDate}</button>
              </section>
            ) : null}
          </Dropdown>
        )}
      </section>
    </main>
  );
}
